import React, { useState } from 'react'
import { Layout, Menu, Tabs, Dropdown, Card, Button, Avatar, Badge, Drawer, theme, Input, Select } from 'antd';
import TradeTable from './TradeTable';
import { SearchOutlined, CheckCircleFilled, UserOutlined, SmileOutlined } from '@ant-design/icons';
import { Divider, Space, Tour } from 'antd';

/*tab asset image */
import t1 from '../Assets/t1.png'
import t2 from '../Assets/t2.png'
import t3 from '../Assets/t3.png'
import t4 from '../Assets/t4.png'
import t5 from '../Assets/t5.png'
import t6 from '../Assets/t6.png'
import t7 from '../Assets/t7.png'
import t8 from '../Assets/t8.png'
import t9 from '../Assets/t9.png'
import btc from '../Assets/btc.png'

const DropDown = ({ children }) => {
    const [dropdownVisible, setDropdownVisible] = useState(false);

    //  tab assets dropdown


    // trade table colums
    const columns = [
        { title: "Sort by Popularity", dataIndex: "name" },
        {
            title: "Price", dataIndex: "quantity", align: "right",
            render: (value) => <span className="quantity-cell">{value}</span>
        },
        { title: " Profit", dataIndex: "margin", align: "center" },


    ];



    const data = [
        {
            key: "1",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />
                NZD/USD (OTC)
            </div>,
            quantity: 148.3233,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },
        {
            key: "2",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />
                USD/JPY (OTC)
            </div>,
            quantity: 0.558625,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },
        {
            key: "1",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />

                GBP/USD (OTC)
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },
        {
            key: "2",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />
                EUR/USD (OTC)
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        }, {
            key: "1",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />

                Gold
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },
        {
            key: "2",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />

                US 30
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },
        {
            key: "2",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />

                US 30
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,
        },
        {
            key: "2",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />

                US 30
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },
        {
            key: "2",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />
                EUR/USD (OTC)
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        }, {
            key: "1",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />

                Gold
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },
        {
            key: "2",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />

                US 30
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },
        {
            key: "2",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />

                US 30
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },
        {
            key: "2",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />
                EUR/USD (OTC)
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        }, {
            key: "1",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />

                Gold
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },
        {
            key: "2",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />

                US 30
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },
        {
            key: "2",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />

                US 30
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },
        {
            key: "2",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />
                EUR/USD (OTC)
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        }, {
            key: "1",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />

                Gold
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },
        {
            key: "2",
            name: <div className="display-1 asset-table">
                <img height="30" src={btc} alt="gold-bars" />

                US 30
            </div>,
            quantity: 4.831385,  // not shown in image
            margin: <div className='prof'>
                88%
            </div>,

        },

    ];

    const trending = (
        <>
            <Input placeholder="Search by name" style={{ width: "100%" }}
                prefix={<SearchOutlined />}
                className='search'
            />
            <div className='p0'>

                <div className='trnd-scrl'>
                    <div className='mt-20'>
                        <Select
                            defaultValue="All Positions"
                            style={{ width: "250px" }}
                            // onChange={handleChange}
                            suffixIcon={<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.66667 10L0 0H14L6.66667 10Z" fill="white" />
                            </svg>
                            }

                            className='history-select'
                            options={[
                                { value: 'AllPositions', label: 'Blits' },
                                { value: 'forex', label: 'Binary' },
                                { value: 'crypto', label: 'Digital' },
                            ]}
                            id='cs'

                        />
                    </div>
                    <div className='display-5 mt-30'>
                        <div className='trnd-h'>
                            Trader's choice
                        </div>
                        <div className='week'>
                            Last week
                        </div>
                    </div>
                    <div className='mt-20'>
                        <Space>
                            <div className='tren-card'>
                                <div className='display-1'>
                                    <img src={btc} width={30} />
                                    <div className='tren-card-h'>
                                        BTC/USD (OTC)
                                    </div>
                                </div>
                                <div className='mt-20 trnd-p'>
                                    Profit
                                    <div className='trnd-p-amt'>
                                        88%
                                    </div>
                                </div>
                                <div className='display-5'>
                                    <div className='mt-20 trnd-p'>
                                        Price
                                        <div className='trnd-p-amt' style={{ color: "#F6F6F7" }}>
                                            1.172085
                                        </div>
                                    </div>
                                    <div className='mt-20 trnd-p'>
                                        5 min change
                                        <div className='trnd-p-amt'>
                                            88%
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='tren-card'>
                                <div className='display-1'>
                                    <img src={btc} width={30} />
                                    <div className='tren-card-h'>
                                        BTC/USD (OTC)
                                    </div>
                                </div>
                                <div className='mt-20 trnd-p'>
                                    Profit
                                    <div className='trnd-p-amt'>
                                        88%
                                    </div>
                                </div>
                                <div className='display-5'>
                                    <div className='mt-20 trnd-p'>
                                        Price
                                        <div className='trnd-p-amt' style={{ color: "#F6F6F7" }}>
                                            1.172085
                                        </div>
                                    </div>
                                    <div className='mt-20 trnd-p'>
                                        5 min change
                                        <div className='trnd-p-amt'>
                                            88%
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='tren-card'>
                                <div className='display-1'>
                                    <img src={btc} width={30} />
                                    <div className='tren-card-h'>
                                        BTC/USD (OTC)
                                    </div>
                                </div>
                                <div className='mt-20 trnd-p'>
                                    Profit
                                    <div className='trnd-p-amt'>
                                        88%
                                    </div>
                                </div>
                                <div className='display-5'>
                                    <div className='mt-20 trnd-p'>
                                        Price
                                        <div className='trnd-p-amt' style={{ color: "#F6F6F7" }}>
                                            1.172085
                                        </div>
                                    </div>
                                    <div className='mt-20 trnd-p'>
                                        5 min change
                                        <div className='trnd-p-amt'>
                                            88%
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Space>

                    </div>
                    <div className='display-5 mt-30'>
                        <div className='trnd-h'>
                            Gainers
                        </div>
                        <div className='week'>
                            Last week
                        </div>
                    </div>
                    <div className='mt-20'>
                        <Space>
                            <div className='tren-card'>
                                <div className='display-1'>
                                    <img src={btc} width={30} />
                                    <div className='tren-card-h'>
                                        BTC/USD (OTC)
                                    </div>
                                </div>
                                <div className='mt-20 trnd-p'>
                                    Profit
                                    <div className='trnd-p-amt'>
                                        88%
                                    </div>
                                </div>
                                <div className='display-5'>
                                    <div className='mt-20 trnd-p'>
                                        Price
                                        <div className='trnd-p-amt' style={{ color: "#F6F6F7" }}>
                                            1.172085
                                        </div>
                                    </div>
                                    <div className='mt-20 trnd-p'>
                                        5 min change
                                        <div className='trnd-p-amt'>
                                            88%
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='tren-card'>
                                <div className='display-1'>
                                    <img src={btc} width={30} />
                                    <div className='tren-card-h'>
                                        BTC/USD (OTC)
                                    </div>
                                </div>
                                <div className='mt-20 trnd-p'>
                                    Profit
                                    <div className='trnd-p-amt'>
                                        88%
                                    </div>
                                </div>
                                <div className='display-5'>
                                    <div className='mt-20 trnd-p'>
                                        Price
                                        <div className='trnd-p-amt' style={{ color: "#F6F6F7" }}>
                                            1.172085
                                        </div>
                                    </div>
                                    <div className='mt-20 trnd-p'>
                                        5 min change
                                        <div className='trnd-p-amt'>
                                            88%
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='tren-card'>
                                <div className='display-1'>
                                    <img src={btc} width={30} />
                                    <div className='tren-card-h'>
                                        BTC/USD (OTC)
                                    </div>
                                </div>
                                <div className='mt-20 trnd-p'>
                                    Profit
                                    <div className='trnd-p-amt'>
                                        88%
                                    </div>
                                </div>
                                <div className='display-5'>
                                    <div className='mt-20 trnd-p'>
                                        Price
                                        <div className='trnd-p-amt' style={{ color: "#F6F6F7" }}>
                                            1.172085
                                        </div>
                                    </div>
                                    <div className='mt-20 trnd-p'>
                                        5 min change
                                        <div className='trnd-p-amt'>
                                            88%
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Space>

                    </div>
                    <div className='display-5 mt-30'>
                        <div className='trnd-h'>
                            Gainers
                        </div>
                        <div className='week'>
                            Last week
                        </div>
                    </div>
                    <div className='mt-20'>
                        <Space>
                            <div className='tren-card'>
                                <div className='display-1'>
                                    <img src={btc} width={30} />
                                    <div className='tren-card-h'>
                                        BTC/USD (OTC)
                                    </div>
                                </div>
                                <div className='mt-20 trnd-p'>
                                    Profit
                                    <div className='trnd-p-amt'>
                                        88%
                                    </div>
                                </div>
                                <div className='display-5'>
                                    <div className='mt-20 trnd-p'>
                                        Price
                                        <div className='trnd-p-amt' style={{ color: "#F6F6F7" }}>
                                            1.172085
                                        </div>
                                    </div>
                                    <div className='mt-20 trnd-p'>
                                        5 min change
                                        <div className='trnd-p-amt'>
                                            88%
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='tren-card'>
                                <div className='display-1'>
                                    <img src={btc} width={30} />
                                    <div className='tren-card-h'>
                                        BTC/USD (OTC)
                                    </div>
                                </div>
                                <div className='mt-20 trnd-p'>
                                    Profit
                                    <div className='trnd-p-amt'>
                                        88%
                                    </div>
                                </div>
                                <div className='display-5'>
                                    <div className='mt-20 trnd-p'>
                                        Price
                                        <div className='trnd-p-amt' style={{ color: "#F6F6F7" }}>
                                            1.172085
                                        </div>
                                    </div>
                                    <div className='mt-20 trnd-p'>
                                        5 min change
                                        <div className='trnd-p-amt'>
                                            88%
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='tren-card'>
                                <div className='display-1'>
                                    <img src={btc} width={30} />
                                    <div className='tren-card-h'>
                                        BTC/USD (OTC)
                                    </div>
                                </div>
                                <div className='mt-20 trnd-p'>
                                    Profit
                                    <div className='trnd-p-amt'>
                                        88%
                                    </div>
                                </div>
                                <div className='display-5'>
                                    <div className='mt-20 trnd-p'>
                                        Price
                                        <div className='trnd-p-amt' style={{ color: "#F6F6F7" }}>
                                            1.172085
                                        </div>
                                    </div>
                                    <div className='mt-20 trnd-p'>
                                        5 min change
                                        <div className='trnd-p-amt'>
                                            88%
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Space>

                    </div>
                </div>
            </div>
        </>

    )

    const option = (
        <>
            <Input placeholder="Search by name" style={{ width: "100%" }}
                prefix={<SearchOutlined />}
                className='search'
            />
            <TradeTable columns={columns} data={data} className={" ast-table mt-20"} />
        </>
    )
    const items = [
        {
            key: '1',
            label: <div className='display-1'>
                <img src={t1} />
                Trending
            </div>,
            children: trending,
        },
        {
            key: '2',
            label: <div className='display-1'>
                <img src={t2} />
                Options
                <Badge
                    className="site-badge"
                    count={109}
                    style={{ backgroundColor: '#7C808A' }}
                />
            </div>,
            children: option,
        },
        {
            key: '3',
            label: <div className='display-1'>
                <img src={t3} />
                Forex

                <Badge
                    className="site-badge"
                    count={109}
                    style={{ backgroundColor: '#7C808A' }}
                />
            </div>,
            children: 'Content of Tab Pane 3',
        },
        {
            key: '4',
            label: <div className='display-1'>
                <img src={t4} />
                Stocks
                <Badge
                    className="site-badge"
                    count={109}
                    style={{ backgroundColor: '#7C808A' }}
                />
            </div>,
            children: 'Content of Tab Pane 3',
        },
        {
            key: '5',
            label: <div className='display-1'>
                <img src={t5} />
                Crypto
                <Badge
                    className="site-badge"
                    count={109}
                    style={{ backgroundColor: '#7C808A' }}
                />
            </div>,
            children: 'Content of Tab Pane 3',
        },
        {
            key: '6',
            label: <div className='display-1'>
                <img src={t6} />
                Commodities
                <Badge
                    className="site-badge"
                    count={109}
                    style={{ backgroundColor: '#7C808A' }}
                />
            </div>,
            children: 'Content of Tab Pane 3',
        },
        {
            key: '7',
            label: <div className='display-1'>
                <img src={t7} />
                ETFs
                <Badge
                    className="site-badge"
                    count={109}
                    style={{ backgroundColor: '#7C808A' }}
                />
            </div>,
            children: 'Content of Tab Pane 3',
        },
        {
            key: '8',
            label: <div className='display-1'>
                <img src={t8} />
                Indices
                <Badge
                    className="site-badge"
                    count={109}
                    style={{ backgroundColor: '#7C808A' }}
                />
            </div>,
            children: 'Content of Tab Pane 3',
        },
        {
            key: '9',
            label: <div className='display-1'>
                <img src={t9} />
                Watchlist
            </div>,
            children: 'Content of Tab Pane 3',
        },
    ];
    const customPanel = (
        <div className='select-asset-tab'>
            <Tabs defaultActiveKey="1" items={items}
                tabPosition='left'
                style={{ height: "100%" }}
                className='asset-tab'
            //  onChange={onChange}
            />
        </div>
    );


    return (
        <Dropdown
            overlay={customPanel}
            trigger={['click']}
            overlayStyle={{
                borderRadius: '16px',
                boxShadow: '0 4px 32px rgba(0,0,0,0.35)',
                background: '#212738',
            }}
            open={dropdownVisible}
            onOpenChange={setDropdownVisible}
        >
            {children}
        </Dropdown>
    )
}

export default DropDown